import React from "react";
import { styled } from "@mui/system";
import MUITablePagination from "@mui/material/TablePagination";
import { TablePaginationProps as TablePaginationPropsMUI } from "@mui/material/TablePagination";
export type TablePaginationProps = {
  component?: React.ElementType;
} & TablePaginationPropsMUI;

const TablePaginationRoot = styled(MUITablePagination, {
  name: "TablePagination",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiTablePagination-root .MuiTablePagination-toolbar": {
    background: theme.palette.primary.surfaceDefault,
    "& .MuiInputBase-root ": {
      marginRight: 16
    },
    "& .MuiTablePagination-actions ": {
      marginLeft: 0
    },
    "& .MuiTablePagination-select": {
      minWidth: 72,
      paddingLeft: 16,
      paddingTop: 5,
      border: "1px solid " + theme.palette.primary.borderDefault,
      background: theme.palette.primary.surfaceDefault,
      height: 40,
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box"
    }
  },
  "&.MuiTablePagination-root .MuiTablePagination-selectLabel": {
    color: theme.palette.primary.main
  },
  "&.MuiTablePagination-root .MuiTablePagination-displayedRows": {
    color: theme.palette.primary.main
  }
}));

export const TablePagination = React.forwardRef<
  HTMLDivElement,
  TablePaginationProps
>(function TablePagination(props, ref) {
  return <TablePaginationRoot {...props} ref={ref} />;
});
